export default "__VITE_ASSET__DsXGjqlb__"